import Navi from "./Navi";
import { ReactComponent as IconHome } from "./Navi/icon/home.svg";
import { ReactComponent as IconTheme } from "./Navi/icon/theme.svg";
import { NaviItemType } from "./interface/Navi.interface";

const navi_item_list: NaviItemType[] = [
    {
        name: "홈",
        icon: IconHome,
        navigate: "/",
    },
    {
        name: "촬영 테마 둘러보기",
        icon: IconTheme,
        navigate: "/themeBook",
    },
];

const AdminNavi = () => {
    return(
        <Navi 
            navi_item_list={navi_item_list}
        />
    )
}

export default AdminNavi;
